export const MODAL_NAMES = {
  SHIPPING_RULES: 'SHIPPING_RULES',
  CATEGORY_DETAILS: 'CATEGORY_DETAILS',
}

export const FORM_IDS = {
  SHIPPING_RULES: 'SHIPPING_RULES',
}
